export enum OrderActionType {
  Buy = 'BUY',
  BuyMargin = 'BUY_MARGIN',
  Sell = 'SELL',
  SellShort = 'SELL_SHORT',
}
